import React, { FC } from 'react';
import styles from './MainWrapper.module.scss';

interface IProps {
    children: React.ReactNode;
}

const MainWrapper: FC<IProps> = ({ children }) => {
    return (
        <div className={styles.container}>{children}</div>
    );
};

export default MainWrapper;